import React from 'react'
import PropTypes from 'prop-types'
import { ProfileConsumer } from 'contexts/profile-context'
import { totalBonusAmount } from 'tools/wallet'

function WalletBalance (props) {
  const { className } = props
  return (
    <ProfileConsumer>
      {profile => {
        if (profile.playableBalance === null) {
          return <span className={className}>...</span>
        }
        const balance = profile.playableBalance - totalBonusAmount(profile.bonuses)
        return (
          <span className={className}>
            {
              balance.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 })
            }
          </span>
        )
      }}
    </ProfileConsumer>
  )
}

WalletBalance.propTypes = {
  removeBonusTotal: PropTypes.bool,
  className: PropTypes.string,
}

export default WalletBalance



// WEBPACK FOOTER //
// ./src/atoms/WalletBalance/WalletBalance.js